export default {
  state: {
    tabs: [
      ' ',
      'description',
      'characteristics',
      'videos',
      'comments',
      'questions',
      'equipment',
      'instructions',
      'combined-products'
    ],
    activeTab: null,
    initialOffset: null,
    isBtnBuyShow: true,
    isHiddenHeader: false
  },
  mutations: {
    CHANGE_ACTIVE_TAB: (state, string) => {
      state.activeTab = string
    },
    CHANGE_INITIAL_OFFSET: (state, offset) => {
      state.initialOffset = offset
    },
    CHANGE_BTN_BUY_SHOW_STATUS: (state, bool) => {
      state.isBtnBuyShow = bool
    },
    CHANGE_IS_HIDDEN_HEADER: (state, bool) => {
      state.isHiddenHeader = bool
    }
  },
  actions: {
    SET_ACTIVE_TAB: ({ commit }, { string, top }) => {
      commit('CHANGE_ACTIVE_TAB', string)

      window.scrollTo({
        top: top
      })

      if (string !== ' ') {
        // Створюємо новий URL-адресу з параметром запиту вкладки
        const url = new URL(window.location.href)
        url.searchParams.set('tab', string)

        // Використовуємо нативний History API браузера для оновлення URL без запуску навігації маршрутизатора
        window.history.pushState({}, '', url.toString())
      }
    },
    SET_INITIAL_OFFSET: ({ commit }, offset) => {
      commit('CHANGE_INITIAL_OFFSET', offset)
    },
    SET_BTN_BUY_SHOW: ({ commit }, bool) => {
      commit('CHANGE_BTN_BUY_SHOW_STATUS', bool)
    },
    SET_IS_HEADER_HIDDEN: ({ commit }, bool) => {
      commit('CHANGE_IS_HIDDEN_HEADER', bool)
    }
  }
}
